/*************************************************

* BAKER HUGHES COMPANY CONFIDENTIAL

* Unpublished work copyright 2025 Baker Hughes Company.  All rights reserved.

*

* This computer code is proprietary and highly confidential to Baker Hughes Company

* and/or its affiliate(s). It may not be used, disclosed, modified, transferred,

* or reproduced without prior written consent, and must be returned on demand.

**************************************************/

import { SvgIcon, SvgIconProps } from '@material-ui/core';

const MenuOpenIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 9C5 8.44772 5.44772 8 6 8H20C20.5523 8 21 8.44772 21 9C21 9.55228 20.5523 10 20 10H6C5.44772 10 5 9.55228 5 9ZM5 16C5 15.4477 5.44772 15 6 15H26C26.5523 15 27 15.4477 27 16C27 16.5523 26.5523 17 26 17H6C5.44772 17 5 16.5523 5 16ZM6 22C5.44772 22 5 22.4477 5 23C5 23.5523 5.44772 24 6 24H16C16.5523 24 17 23.5523 17 23C17 22.4477 16.5523 22 16 22H6Z"
    />
  </SvgIcon>
);

export default MenuOpenIcon;
